<template>
    <div>
        <div class="alinhar-info justify-space-between mb-2 mt-2 acao-expandir-recolher">
            <h3 class="titulo">Listagem</h3>

            <div v-if="reajusteItens.length > 1" class="text-xs-right">
                <v-btn v-if="ultimoEstadoTodosPaineis === 'recolhidos'" flat @click="expandirTodos"
                       class="botao-simples mr-3">
                    <v-icon left size="15">fas fa-chevron-down</v-icon>
                    Expandir Todos
                </v-btn>
                <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
                    <v-icon left size="15">fas fa-chevron-up</v-icon>
                    Recolher Todos
                </v-btn>
            </div>
        </div>

        <v-expansion-panel v-model="paineis" expand class="painel-itens">

            <v-expansion-panel-content v-for="reajusteItem in reajusteItens"
                                       :key="reajusteItem.id"
                                       class="painel-itens__linha borda-linha cabecalho-painel">
                <template v-slot:header>
                    <div class="alinhar-info">
                        <span v-if="reajusteItem.rotulo">
                            <strong>{{ reajusteItem.rotulo }}</strong>
                        </span>
                        <span v-else>&nbsp;-&nbsp;</span>

                        <span class="ml-4">
                            <strong>Arrematado por:&nbsp;</strong>
                            <span v-if="reajusteItem.valorArrematado">
                                {{reajusteItem.valorArrematado | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                            </span>
                            <span v-else>&nbsp;-&nbsp;</span>
                        </span>

                        <AreaNegociacao v-if="reajusteItem.negociacao"
                                        :itemLote="reajusteItem"
                                        :aceita-valor-zero="aceitaValorZero"
                                        :casasDecimais="casasDecimais"
                                        :criterioJulgamento="criterioJulgamentoDaCompra"
                                        :simboloCriterioJulgamento="simboloCriterioJulgamentoDaCompra"
                                        :validarLancesPor="validarIntervaloLancesPor"
                                        :prefixSuffixValor="prefixOuSuffixValor"
                                        @atualizarValorNegociacao="atualizarValorNegociacao"
                                        @aceitarNegociacao="aceitarNegociacao"
                        />
                    </div>

                    <div class="painel-itens__info">
                        <p>Exclusivo {{formatarLista(portes) | azConcat}}:</p>
                        <p class="ml-2">{{ reajusteItem.porteExclusivo ? 'Sim' : 'Não' }}</p>
                    </div>

                </template>

                <painel-item-tabela :itemReajuste="reajusteItem"
                                    :situacaoReajusteItem="reajusteItem.situacao"
                                    :totalMaiorQueNegociado="verificarSeTotalMaiorQueNegociado(reajusteItem)"
                                    :criterioJulgamento="criterioJulgamentoDaCompra"
                                    :simboloCriterioJulgamento="simboloCriterioJulgamentoDaCompra"
                                    :validarLancesPor="validarIntervaloLancesPor"
                                    :prefixSuffixValor="prefixOuSuffixValor"
                                    :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                    :casasDecimais="casasDecimais"
                                    :casasDecimaisQuantidade="casasDecimaisQuantidade"
                                    @salvarItem="salvarItemDoReajuste"/>

                <hr style="color: #EFEFEF;"  v-if="deveMostrarBotaoAnexarReadequacao(reajusteItem)">
                <div class="painel-itens__info mb-2 py-2" v-show="deveMostrarBotaoAnexarReadequacao(reajusteItem)">
                          <botao-enviar-readequacao v-if="deveMostrarBotaoAnexarReadequacao(reajusteItem)"
                                                  @eventoAbrirModalReadequacao="eventoAbrirModalReadequacao(reajusteItem)"/>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
import PainelItemTabela from './PainelItemTabela'
import AreaNegociacao from '../negociacao/AreaNegociacao'
import BotaoEnviarReadequacao from '@/views/pages/fornecedor/resultado/documento-proposta/reajuste/painel-lote/BotaoEnviarReadequacao'
export default {
    name: 'PainelItem',
    props: {
        reajusteItens: {
            type: Array,
            default: () => []
        },
        tipoCompraDireta: {
            type: String,
            default: null
        },
        disputaCompraDireta: {
            type: String,
            default: null
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        aceitaValorZero:{
            type: Boolean
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    components: {
        BotaoEnviarReadequacao,
        AreaNegociacao,
        PainelItemTabela
    },
    mounted() {
        this.expandirTodos()
    },
    data() {
        return {
            paineis: [],
            ultimoEstadoTodosPaineis: 'recolhidos',
            totalmenteRecolhido: false,
            totalmenteExpandido: true,
        }
    },
    computed:{
        criterioJulgamentoDaCompra(){
            return this.criterioJulgamento
        },
        simboloCriterioJulgamentoDaCompra(){
            return this.simboloCriterioJulgamento
        },
        prefixOuSuffixValor(){
            return this.prefixSuffixValor
        },
        validarIntervaloLancesPor(){
            return this.validarLancesPor
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        }
    },
    methods: {
        atualizarValorNegociacao(dados) {
            const item = dados.itemLote
            item.negociacao.valor = dados.valor
        },
        salvarItemDoReajuste(item) {
            this.$emit('salvarItemReajuste', item)
        },
        aceitarNegociacao(dados) {
            const item = dados.itemLote
            const aceito = dados.aceito
            this.$emit('aceitarNegociacaoItem', {
                id: item.negociacao.id,
                itemOuLoteReajusteId: item.id,
                itemOuLoteCompraDiretaId: item.itemCompraDiretaId,
                tipo: 'ITEM',
                aceito: aceito,
                valor: aceito? item.negociacao.valor : null
            })
        },
        verificarSeTotalMaiorQueNegociado(item) {
            if (item.negociacao && item.negociacao.aceito) {
                if (this.tipoCompraDireta === 'COM_DISPUTA' && this.disputaCompraDireta === 'UNITARIO') {
                    return item.valorUnitarioReajustado > item.negociacao.valor
                } else {
                    return item.valorTotal > item.negociacao.valor
                }
            } else {
                return false
            }
        },
        expandirTodos() {
            this.paineis = this.reajusteItens.map(() => {
                return true
            })
            this.totalmenteExpandido = true
        },
        recolherTodos() {
            this.paineis = this.reajusteItens.map(() => {
                return false
            })
            this.totalmenteExpandido = false
        },
        verificarEstadoPaineis(){
            this.totalmenteExpandido = !this.paineis.some(painel => painel === false)
            this.totalmenteRecolhido = !this.paineis.some(painel => painel === true)

            if (this.totalmenteExpandido) {
                this.ultimoEstadoTodosPaineis = 'expandidos'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoTodosPaineis = 'recolhidos'
            }
        },
        formatarValorOuPercentual(valor){
            if(this.criterioJulgamento === 'MAIOR_DESCONTO')
                return `${valor}${this.simboloCriterioJulgamento}`

            return `${this.simboloCriterioJulgamento} ${valor}`
        },
        eventoAbrirModalReadequacao(reajusteItem){
            this.$emit('eventoAbrirModalReadequacao', reajusteItem)
        },
        deveMostrarBotaoAnexarReadequacao(reajusteItem){
            return reajusteItem.documentoApresentadoId && !reajusteItem.uriReadequacao
        }
    },
    watch: {
        paineis() {
            this.verificarEstadoPaineis()
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-chip.v-chip--outline
        border none

    .v-chip .v-icon--left
        margin-right 6px

    .v-btn--icon
        width 26px

    .v-btn
        height 26px
        margin 0

    .v-chip--active, .v-chip--selected, .v-chip:focus:not(.v-chip--disabled)
        box-shadow none

    .v-chip--active:after, .v-chip--selected:after, .v-chip:focus:not(.v-chip--disabled):after
        background none

    .alinhar-info
        display flex
        align-items center

    .titulo
        font-size 1.1rem
        color #777
        margin-left 16px
        clear both

    .painel-itens__info
        margin-right 10px

    @media (max-width 720px)
        .painel-itens__info
            margin-right 10px
</style>